
const DESIGN_ID = '8f0af0eb-0000-0000-0000-mock00000004';

const designDocument = {
  ModularDesignType: 'WallStorage',
  Id: DESIGN_ID,
  DesignName: 'Mock 2-Plate Horizontal Bundle (Loaded)',
  Version: 1,
  ProductTypeId: 97,
  Sku: null,
  Surface: null,
  Matrix: { Rows: 1, Columns: 6, Segments: null },
  Cart: [],
  IsLocked: false,
  ProductsHash: null,
  ProjectId: null,
  Created: '2026-01-01T00:00:00.000Z',
  LastModified: '2026-01-01T00:00:00.000Z',
  Products: [
    {
      InstanceId: '61f437dc-5c1c-4a3f-a1c8-1535890f43a6',
      Sku: 329930935,
      Name: '20 in. x 30.75 in. Wall Plate in Black',
      Type: 'Frame',
      Origin: { Height: 2000, Width: 3075, Row: 0, Column: 100 },
      ParentIds: null,
      DefaultIds: [],
      ChildrenIds: [
        'b8f42c22-1ae4-40b8-80bb-a633d33ebd06',
        'a59a4bb5-d7a8-47c5-925c-ad6f7d199f48',
        '82a1b172-5e14-4e96-ae99-43dc47ab8a38',
        'd582ebb2-0bdc-4207-90da-848f1644e71c',
      ],
      Attachment: null,
      Precedence: 1,
      ChoiceId: 265405,
      ChoiceBundle: null,
      TargetArea: null,
    },
    {
      InstanceId: '9d8f2af7-5997-491c-8207-4d6a7b481102',
      Sku: 329930935,
      Name: '20 in. x 30.75 in. Wall Plate in Black',
      Type: 'Frame',
      Origin: { Height: 2000, Width: 3075, Row: 0, Column: 400 },
      ParentIds: null,
      DefaultIds: [],
      ChildrenIds: [
        'c21742fd-82cc-4bbf-be2a-f03bb56b1a48',
        '305e75c4-056d-47d0-9115-d3da0e213b89',
        'b8f42c22-1ae4-40b8-80bb-a633d33ebd06',
      ],
      Attachment: null,
      Precedence: 1,
      ChoiceId: 265405,
      ChoiceBundle: null,
      TargetArea: null,
    },
    {
      InstanceId: 'c21742fd-82cc-4bbf-be2a-f03bb56b1a48',
      Sku: 320052193,
      Name: 'PACKOUT Large Hook',
      Type: 'Hook',
      Origin: { Row: 1150, Column: 2375, Height: 850, Width: 700 },
      ParentIds: ['9d8f2af7-5997-491c-8207-4d6a7b481102'],
      DefaultIds: [],
      ChildrenIds: [],
      Attachment: { Mode: 'dropzone', Data: { dropzoneId: 'ap-fp2-r1-c1' } },
      Precedence: 2,
      ChoiceId: 265423,
      ChoiceBundle: null,
      TargetArea: null,
    },
    {
      InstanceId: '305e75c4-056d-47d0-9115-d3da0e213b89',
      Sku: 325001890,
      Name: 'PACKOUT 7-Hook Rack Tool Holder',
      Type: 'Rack',
      Origin: { Row: 0, Column: 0, Height: 350, Width: 950 },
      ParentIds: ['9d8f2af7-5997-491c-8207-4d6a7b481102'],
      DefaultIds: [],
      ChildrenIds: [],
      Attachment: { Mode: 'dropzone', Data: { dropzoneId: 'ap-fp2-r0-c0' } },
      Precedence: 2,
      ChoiceId: 265417,
      ChoiceBundle: null,
      TargetArea: null,
    },
    {
      InstanceId: 'b8f42c22-1ae4-40b8-80bb-a633d33ebd06',
      Sku: 320324795,
      Name: 'Packout 19.5 in. W x 14.7 in. H x 14.5 in. D Cabinet in Red (1-Piece)',
      Type: 'Accessory',
      Origin: { Row: 0, Column: 0, Height: 1470, Width: 1950 },
      ParentIds: [
        '61f437dc-5c1c-4a3f-a1c8-1535890f43a6',
        '9d8f2af7-5997-491c-8207-4d6a7b481102',
      ],
      DefaultIds: [],
      ChildrenIds: [],
      Attachment: { Mode: 'dropzone', Data: { dropzoneId: 'ap-fp2-r0-c0' } },
      Precedence: 2,
      ChoiceId: 265425,
      ChoiceBundle: null,
      TargetArea: null,
    },
    {
      InstanceId: 'a59a4bb5-d7a8-47c5-925c-ad6f7d199f48',
      Sku: 305821962,
      Name: 'PACKOUT 5-Compartment Low-Profile Compact Small Parts Organizer',
      Type: 'Accessory',
      Origin: { Row: 0, Column: 0, Height: 1620, Width: 980 },
      ParentIds: ['61f437dc-5c1c-4a3f-a1c8-1535890f43a6'],
      DefaultIds: [],
      ChildrenIds: [],
      Attachment: { Mode: 'dropzone', Data: { dropzoneId: 'ap-fp1-r0-c0' } },
      Precedence: 2,
      ChoiceId: 265400,
      ChoiceBundle: null,
      TargetArea: null,
    },
    {
      InstanceId: '82a1b172-5e14-4e96-ae99-43dc47ab8a38',
      Sku: 320052829,
      Name: 'PACKOUT Small Straight Utility Hook',
      Type: 'Hook',
      Origin: { Row: 1100, Column: 300, Height: 400, Width: 350 },
      ParentIds: ['61f437dc-5c1c-4a3f-a1c8-1535890f43a6'],
      DefaultIds: [],
      ChildrenIds: [],
      Attachment: { Mode: 'dropzone', Data: { dropzoneId: 'ap-fp0-r1-c1' } },
      Precedence: 2,
      ChoiceId: 265422,
      ChoiceBundle: null,
      TargetArea: null,
    },
    {
      InstanceId: 'd582ebb2-0bdc-4207-90da-848f1644e71c',
      Sku: 320052829,
      Name: 'PACKOUT Small Straight Utility Hook',
      Type: 'Hook',
      Origin: { Row: 1500, Column: 0, Height: 400, Width: 350 },
      ParentIds: ['61f437dc-5c1c-4a3f-a1c8-1535890f43a6'],
      DefaultIds: [],
      ChildrenIds: [],
      Attachment: { Mode: 'dropzone', Data: { dropzoneId: 'ap-fp0-r2-c0' } },
      Precedence: 2,
      ChoiceId: 265422,
      ChoiceBundle: null,
      TargetArea: null,
    },
  ],
};

const wallStorageBundleLoadedMock = [
  {
    Id: DESIGN_ID,
    DesignDocument: JSON.stringify(designDocument),
  },
];

export default wallStorageBundleLoadedMock;
